import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ee3f64f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "notification-dot"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'base-notification-dot',
  props: {
    hasUnread: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (__props.hasUnread)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1))
    : _createCommentVNode("", true)
}
}

})